export enum DispatchStatus {
    ANY,
    FAIL,
    SUCCESS,
    PENDING,
    BOOKING_UPDATE
}
